// @flow

import { observer } from "mobx-react";
import React from "react";

import Video from "app/models/Video";
import TimelineItem from "app/models/TimelineItem";

import TimelineDotRange from "app/components/TimelineDotRange/TimelineDotRange";
import TimelinePositioner from "app/components/TimelinePositioner/TimelinePositioner";

import "./TimelineDots.scss";

type Props = {
    video: Video,
    progress?: number,
    items: TimelineItem[],
    selectedItem?: ?TimelineItem
};

@observer
export default class TimelineDots extends React.Component<Props> {
    render() {
        return (
            <div className="TimelineDots">
                {this.props.items.map((item: TimelineItem) => {
                    return this.renderPositioner(item);
                })}
            </div>
        );
    }

    renderPositioner(item: TimelineItem) {
        const selectedItem: any = this.props.selectedItem;
        return (
            <TimelinePositioner
                key={item.key}
                video={this.props.video}
                item={item}
                selectedItem={selectedItem}
                scale={1}
            >
                <TimelineDotRange
                    item={item}
                    progress={this.props.progress || 0}
                    selected={this.props.selectedItem === item}
                />
            </TimelinePositioner>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineDots/TimelineDots.js